module.exports = __webpack_public_path__ + "img/NoorPlayLogo.55dc5764.png";